module.exports = __webpack_public_path__ + "img/aetnadental.471fb9bb.png";